/* eslint-disable no-debugger */
import { createSlice } from '@reduxjs/toolkit';
import { ScreenState } from '@enums/index';
import { getDashboardAsync } from './thunks';
import { Dashboard } from './types';

export interface DashboardStore {
  state: ScreenState;
  error?: string;
  data: Dashboard;
}

const initialState: DashboardStore = {
  state: ScreenState.Loading,
  error: '',
  data: {} as Dashboard,
};

export const DashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDashboardAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(getDashboardAsync.rejected, (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    });
    builder.addCase(getDashboardAsync.fulfilled, (state, action) => {
      state.data.portfolios = action.payload;
      state.state = ScreenState.SuccessDataLoaded;
    });
  },
});

export default DashboardSlice.reducer;
